export type StatusType = "idle" | "loading" | "success" | "error" | "reviewing" | "claiming" | "claimed";

export enum Status {
  Idle = "idle",
  Loading = "loading",
  Success = "success",
  Error = "error",
  Reviewing = "reviewing",
  Claiming = "claiming",
  Claimed = "claimed"
}

export const DisabledStatus = [Status.Loading, Status.Success, Status.Claimed, Status.Claiming];
